import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { DialogCloseResponse } from "./dialog-default-modal.models";
import { boostThemeEnum } from "@app/services/page.service";
import { AngularSvgIconModule } from "angular-svg-icon";
import { ButtonComponent } from "../button/button.component";
@Component({
  selector: "app-dialog-default-modal",
  templateUrl: "./dialog-default-modal.component.html",
  styleUrls: ["./dialog-default-modal.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    AngularSvgIconModule,
    ButtonComponent,
  ],
})
export class DialogDefaultModalComponent implements AfterViewInit {
  @Input() confirmText: string = "Yes";
  @Input() cancelText: string = "No";
  @Input() showActions: boolean = true;
  @Input() showCloseIcon: boolean = true;
  @Input() addContentPadding: boolean = true;
  @Input() showScrollbar: boolean = true;
  @Input() dialogSurfaceBackground: boostThemeEnum = boostThemeEnum.none;
  @Input() dialogCloseIconColor: boostThemeEnum = boostThemeEnum.forestpath;
  @Input() dialogType: "confirmation" | "edit" | "none" = "confirmation";
  // Disables the default confirm button (e.g. to gate Save on a valid form / required selection).
  @Input() confirmDisabled: boolean = false;

  @ViewChild("customActionsContainer") customActionsContainer: ElementRef;
  @Output() actionClicked = new EventEmitter<DialogCloseResponse>();

  private _hasCustomActions: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogDefaultModalComponent>,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    // Use setTimeout to ensure content projection has completed
    setTimeout(() => {
      this._hasCustomActions =
        this.customActionsContainer?.nativeElement?.children?.length > 0;
      this.cdr.detectChanges();
    });
  }

  get hasCustomActions(): boolean {
    return this._hasCustomActions;
  }
}
